import { LazyLoad } from 'app/utils';

export const ShopListPage = LazyLoad(
  () => import('./index'),
  (module) => module.ShopListPage,
);
